/* eslint-disable */
import BasicLayout from '@/layouts/basic-layout'

const meta = {
  auth: true,
}

const pre = 'drp-'

export default {
  path: '/drp',
  name: 'drp',
  redirect: {
    name: `${pre}drp1`,
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: 'drp1',
      name: `${pre}drp1`,
      meta: {
        ...meta,
        title: '采购商品',
      },
      component: () => import('@/pages/drp/drp1'),
    },
    {
      path: 'drp2',
      name: `${pre}drp2`,
      meta: {
        ...meta,
        title: '采购明细',
      },
      component: () => import('@/pages/drp/drp2'),
    },
    {
      path: 'drp3',
      name: `${pre}drp3`,
      meta: {
        ...meta,
        title: '采购退货',
      },
      component: () => import('@/pages/drp/drp3'),
    },
    {
      path: 'drp4',
      name: `${pre}drp4`,
      meta: {
        ...meta,
        title: '采购退货明细',
      },
      component: () => import('@/pages/drp/drp4'),
    },
    {
      path: 'stock',
      name: `${pre}stock`,
      meta: {
        ...meta,
        title: '库存管理',
      },
      component: () => import('@/pages/drp/stock'),
    },
    {
      path: 'supplier',
      name: `${pre}supplier`,
      meta: {
        ...meta,
        title: '供应商管理',
      },
      component: () => import('@/pages/drp/supplier'),
    },
    {
      path: 'product',
      name: `${pre}product`,
      meta: {
        ...meta,
        title: '产品管理',
      },
      component: () => import('@/pages/drp/product'),
    },
    {
      path: 'product1',
      name: `${pre}product1`,
      meta: {
        ...meta,
        title: '采购详情',
      },
      component: () => import('@/pages/drp/product1'),
    },
    {
      path: 'product2',
      name: `${pre}product2`,
      meta: {
        ...meta,
        title: '退货详情',
      },
      component: () => import('@/pages/drp/product2'),
    },
    {
      path: 'drp5',
      name: `${pre}drp5`,
      meta: {
        ...meta,
        title: '采购管理',
      },
      component: () => import('@/pages/drp/drp5'),
    },
    {
      path: 'print',
      name: `${pre}print`,
      meta: {
        ...meta,
        title: '订单打印',
      },
      component: () => import('@/pages/drp/print'),
    },
  ],
}
